import { Typography } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import PropTypes from "prop-types";
import React from "react";

import HNSColors from "../../../../../ui library/HNSColors";
import AddButton from "../../../provider-management/components/buttons/AddButton";
import CancelButton from "../../../provider-management/components/buttons/CancelButton";
import SaveButton from "../../../provider-management/components/buttons/SaveButton";

import EmptyTimeWindow from "./EmptyTimeWindow";
import TimeWindowRow from "./TimeWindowRow";

export default function EditHoursCell({
  canAdd,
  canDelete,
  day,
  dayIndex,
  hasUnsavedChanges,
  onAdd,
  onChange,
  onDelete,
  onDone,
  onSave,
  timings,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="flex flex-col gap-3">
        {canAdd ? (
          <div className="flex flex-row justify-between py-2">
            <div className="flex flex-col gap-1">
              <Typography className="text-[14px] font-semibold" sx={{ color: HNSColors.neutrals[100] }}>{day}</Typography>
              <Typography className="text-[12px] font-normal">Edit Time Window</Typography>
            </div>
            <AddButton label="Add new time window" handleAdd={() => onAdd(dayIndex)} />
          </div>
        ) : null}
        {!timings.length ? <EmptyTimeWindow /> : timings.map((time, timingIndex) => (
          <TimeWindowRow
            key={time.id ?? `${dayIndex}-${timingIndex}`}
            canDelete={canDelete}
            dayIndex={dayIndex}
            timingIndex={timingIndex}
            time={time}
            onChange={onChange}
            onDelete={onDelete}
          />
        ))}
        <div className="flex w-full justify-end py-4">
          <div className="flex w-full gap-2 md:w-1/2 md:justify-end">
            <CancelButton disabled={false} onClick={() => onDone(dayIndex)} />
            <SaveButton
              disabled={!hasUnsavedChanges}
              onClick={() => onSave(dayIndex)}
              label="Save"
            />
          </div>
        </div>
      </div>
    </LocalizationProvider>
  );
}

EditHoursCell.propTypes = {
  canAdd: PropTypes.bool.isRequired,
  canDelete: PropTypes.bool.isRequired,
  day: PropTypes.string.isRequired,
  dayIndex: PropTypes.number.isRequired,
  hasUnsavedChanges: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  timings: PropTypes.array.isRequired,
};
